import { render, staticRenderFns } from "./StepBasicInfo.vue?vue&type=template&id=5c666b04&scoped=true"
import script from "./StepBasicInfo.vue?vue&type=script&lang=ts"
export * from "./StepBasicInfo.vue?vue&type=script&lang=ts"
import style0 from "./StepBasicInfo.vue?vue&type=style&index=0&id=5c666b04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c666b04",
  null
  
)

export default component.exports